// components/Dashboard/ProgressCard.jsx
import React from "react";
import { Text } from "@fluentui/react-components";

function ProgressBar({ value, color = "#0066FF", label, height = 8 }) {
  const pct = Math.min(100, Math.max(0, (value || 0) * 100));
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
        <Text style={{ fontSize: 12, color: "#605E5C" }}>{label}</Text>
        <Text style={{ fontSize: 12, fontWeight: 600, color: "#201F1E" }}>{pct.toFixed(0)}%</Text>
      </div>
      <div
        style={{
          height,
          background: "#EDEBE9",
          borderRadius: height,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${pct}%`,
            background: color,
            borderRadius: height,
            transition: "width 0.6s ease",
          }}
        />
      </div>
    </div>
  );
}

export default function ProgressCard({ title, items, icon, style = {} }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 16,
        padding: 24,
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
        border: "1px solid #EDEBE9",
        ...style,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
        {icon && (
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: "linear-gradient(135deg, #0052CC, #0066FF)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: 18,
            }}
          >
            {icon}
          </div>
        )}
        <Text weight="semibold" size={400} style={{ color: "#201F1E" }}>
          {title}
        </Text>
      </div>

      {items.map((item, i) => (
        <ProgressBar key={i} {...item} />
      ))}
    </div>
  );
}
